import 'whatwg-fetch'
import Cookie from 'js-cookie'
import { message } from 'antd'
import config from '../config'

let env = process.env.REACT_APP_BM_ENV || 'development'
export let api: string = config[env].apiDomain

export const dataToString = (data: object, method: string) => {
  if (method === 'GET') {
    const array: any = []
    let index = 0
    for (const item in data) {
      if (data[item]) {
        array[index++] = [item, data[item]]
      }
    }
    return new URLSearchParams(array).toString()
  }
  return JSON.stringify(data)
}

export const clearAllCookie = () => {
  const date: any = new Date();
  date.setTime(date.getTime() - 10000);
  const keys=document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
      for (let i = keys.length; i--;) {
        document.cookie=keys[i]+"=0; expire=" + date.toGMTString() + "; path=/";
      }   
  }
}

export const fetchAPI = (
  url: string,
  data?: object,
  method: string = 'GET'
): Promise<Response> => {
  let initObj: any = {
  }
  let userId = Cookie.get('bm_user_id');
  const userID = Cookie.get('userID');

  url = api + url

  if (userId && userID) {
    url = url + '?_current_user_id=' + userId + '&userID=' + userID
  } else if (userId && !userID) {
    url = url + '?_current_user_id=' + userId
  } else if (!userId && userID) {
    url = url + '?userID=' + userID
  }

  let dataStr = ''
  if (data) {
    dataStr = dataToString(data, method)
  }
  if (method === 'GET') {
    if (data) {
      if (url.indexOf('?') > -1) {
        url += '&' + dataStr
      } else {
        url += '?' + dataStr
      }
    }
  } else {
    initObj = {
      body: dataStr,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      method
    }
  }
  initObj.credentials = 'include';  
  return new Promise((resolve, reject) => {
    fetch(url, initObj).then(response => {
      if (response.ok) {
        return response.json()
      }
      // 后台报错，执行后面的catch方法
      return reject({
        status: response.status
      })
    }).then(response => {
      if (response.code === 200) {
        resolve(response.data)
      } else if (response.code === 103) {
        // 登录态失效
        message.error('登录失效')
        window.location.href = `${config[env].loginDomain}?redirect=${window.location.origin}&app_name=cpc_bm&tplid=3`
        reject('登录失效')
      } else if (response.code === 106) {
        // 登录态冲突刷新页面
        window.location.reload()
        reject('登录失效')
      } else if (response.code === 109) {
        // 非有效的登录态，需要提示，重新登录 
        window.location.href = `${window.location.origin}/pure/invalid`
        reject('登录失效')
      } else {
        message.error(response.message)
        reject(response.message)
      }
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.tsx